import * as React from "react";
import classnames from "classnames";
import { H2 } from "@grandvisionhq/iris-ui";
import { PurchaseTypeSelectionBox } from "../../../../components/modules/EcommContent/components/PurchaseTypeSelectionBoxes/components/PurchaseTypeSelectionBox.js";
/* empty css                                */
import { pushPurchaseTypeSelectionEvent } from "../../../../../../../Analytics/events/modules/Analytics/events/subscription-events.js";
import { useCmsData } from "../../../../../../../../context/context/CmsContext.js";
import { isInStoreSubscriptionPurchase, isSubscriptionPurchase } from "../../../../../../../../types/types/typeguards.js";
import { SUBSCRIPTION_PURCHASE, SINGLE_PURCHASE } from "../../../../../../../../types/types/purchase-types.js";
const getBadgePrice = (purchaseTypeKey, purchaseTypePrices) => {
  if (isSubscriptionPurchase(purchaseTypeKey)) {
    return purchaseTypePrices[SUBSCRIPTION_PURCHASE];
  }
  if (isInStoreSubscriptionPurchase(purchaseTypeKey)) {
    return void 0;
  }
  return purchaseTypePrices[SINGLE_PURCHASE];
};
const PurchaseTypeSelectionBoxes = React.memo(
  ({
    className,
    onSelection,
    purchaseTypePrices,
    selectedPurchaseType,
    isAvailableForInStoreSubscription,
    subscriptionTypeAllowed
  }) => {
    const { purchaseTypeDocument } = useCmsData();
    const handleOnSelection = React.useCallback(
      (purchaseTypeKey) => {
        onSelection(purchaseTypeKey);
        pushPurchaseTypeSelectionEvent(purchaseTypeKey);
      },
      [onSelection]
    );
    if (!purchaseTypeDocument) {
      return null;
    }
    const { purchaseTypes, title } = purchaseTypeDocument;
    const filteredPurchaseTypes = purchaseTypes.filter((type) => {
      if (!isAvailableForInStoreSubscription && isInStoreSubscriptionPurchase(type.key)) {
        return false;
      }
      if (!subscriptionTypeAllowed && isSubscriptionPurchase(type.key)) {
        return false;
      }
      return true;
    });
    if (filteredPurchaseTypes.length < 2) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("div", { className: classnames("purchase-type-selection-boxes", className) }, title && /* @__PURE__ */ React.createElement(H2, { className: "purchase-type-selection-boxes__title", variant: "heading-smallest" }, title), /* @__PURE__ */ React.createElement("fieldset", { "aria-label": title }, filteredPurchaseTypes.map((purchaseType) => {
      const badgePrice = getBadgePrice(purchaseType.key, purchaseTypePrices);
      return /* @__PURE__ */ React.createElement(
        PurchaseTypeSelectionBox,
        {
          key: purchaseType.key,
          value: purchaseType.key,
          "data-t": purchaseType.key,
          title: purchaseType.title,
          description: purchaseType.description,
          onChange: handleOnSelection,
          isSelected: purchaseType.key === selectedPurchaseType,
          badgePrice
        }
      );
    })));
  }
);
export {
  PurchaseTypeSelectionBoxes
};
//# sourceMappingURL=PurchaseTypeSelectionBoxes.js.map
